import React, { useContext, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import { VenueSearchResult } from "Services/API/API";
import { useSpaceExpert } from "Components/Embedded/SpaceExpert";
import { Button } from "Components/ReactstrapSlim";
import { ModuleCaption } from "Components/Module";
import { useModulePager } from "Hooks";
import { SearchContext } from "../../Main/SearchContextProvider";
import ModulePager from "../../ModulePager";
import ModulePagerControls from "../../ModulePager/ModulePagerControls";
import { VenueCard } from "../../VenueCard";

interface NearbyTabProps {
   onVenueCardClick: (e: React.SyntheticEvent, venue: VenueSearchResult) => void;
   controlsElement: HTMLElement | null;
}

const NearbyTab: React.FC<NearbyTabProps> = ({ onVenueCardClick, controlsElement }) => {
   const searchManager = useContext(SearchContext);
   const spaceExpertDialog = useSpaceExpert();

   const nearbyPager = useModulePager({
      itemCount: searchManager.locations.length,
      itemWidth: 256,
      gapWidth: 32
   });

   const nonExtendedVenues = useMemo(() => searchManager.locations.filter(x => !x.isExtendedNetwork), [searchManager.locations]);

   useEffect(() => {
      nearbyPager.reset();
   }, [searchManager.locations]);

   return <div className="tap-pane active">
      {
         controlsElement != null
            ? createPortal(<>
               {nearbyPager.displayControls && <Button color="arctic-20" size="sm" onClick={() => window.open(searchManager.currentSearchLink(), "_blank")}>View All</Button>}
               <ModulePagerControls pager={nearbyPager} />
            </>, controlsElement)
            : null
      }

      {
         !searchManager.isSearching && !nonExtendedVenues.length
            ? <div className="explore-nearby-null-state">
               <ModuleCaption className="mb-px8">Yikes, no spaces match your search results</ModuleCaption>
               <div className="mb-px24">Adjust your search to see more results or let our team know if you need help</div>
               <Button color="arctic-20" size="sm" onClick={() => spaceExpertDialog.openSpaceExpert(LSCommon.Enums.SavedSearchSourceType.BrandedPortal)}>Connect</Button>
            </div>
            : <ModulePager
               pager={nearbyPager}
               items={nonExtendedVenues}
               renderItem={(venue, style) =>
                  <VenueCard
                     key={venue.venueId}
                     venue={venue}
                     onClick={onVenueCardClick}
                     style={style}
                  />}
            />
      }
   </div>
}

export default NearbyTab;